<script lang="ts" setup>
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { Float } from '@headlessui-float/vue'
import browseJobEmployement from '~/assets/data/browsejob-employement.json'

interface Props {
  oriJob: string[]
}

const props = defineProps<Props>()
const emit = defineEmits(['update:modelValue'])
const arrJob = ref([])

onMounted(() => {
  arrJob.value = props.oriJob
})

watch(() => props.oriJob, (value) => {
  // to watch parent reset
  arrJob.value = value
})

function setValue(event: any, val: string) {
  event.preventDefault()
  if (arrJob.value.includes(val))
    arrJob.value = arrJob.value.filter(obj => obj !== val)
  else
    arrJob.value.push(val)

  emit('update:modelValue', arrJob.value)
}

function resetValue() {
  arrJob.value = []
  emit('update:modelValue', arrJob.value)
}
</script>

<template>
  <div>
    <Menu v-slot="{ open }" as="div" class="relative bg-white text-sm">
      <Float portal placement="bottom-start" :z-index="0">
        <MenuButton :class="`${open ? 'border-primary-400' : ''} ${!isEmpty(arrJob) ? 'border-primary-400 bg-[#ECE9FC] text-[#5843E5] font-semibold' : 'bg-white border-gray-200'} flex items-center relative pl-4 pr-10 py-1.5 rounded-md text-sm border`">
          <span class="block truncate">{{ !isEmpty(arrJob) ? arrJob.length : '' }} Job Type</span>
          <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <Icon v-if="!open" name="mdi:chevron-down" class="h-4 w-4" aria-hidden="true" />
            <Icon v-else name="mdi:chevron-up" class="h-4 w-4" aria-hidden="true" />
          </span>
        </MenuButton>
        <div v-show="open">
          <MenuItems static class="origin-bottom-right absolute w-full lg:w-56 mt-1 rounded-md shadow-lg p-4 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
            <MenuItem class="flex items-center mb-2" as="div">
              <div class="font-bold">
                Job Type
              </div>
              <div v-if="oriJob.length > 0" class="text-[#5843E5] ml-auto text-sm cursor-pointer font-semibold" @click="resetValue()">
                Reset
              </div>
            </MenuItem>
            <MenuItem v-for="(item, idx) in browseJobEmployement" :key="idx" :value="item.data" as="div" :class="`${idx < (browseJobEmployement.length - 1) ? 'border-b-1' : ''} cursor-pointer py-4 flex items-center`" @click="setValue($event, item.value)">
              <input :id="`arrJob${idx}`" v-model="arrJob" :name="`arrJob${idx}`" :value="item.value" type="checkbox" class="border-gray-300 border-2 rounded-sm h-4 w-4 focus:ring-primary-600 text-primary-600 checked:bg-primary-600 cursor-pointer">
              <span :for="`arrJob${idx}`" class="text-sm ml-4">{{ item.label }}</span>
            </MenuItem>
          </MenuItems>
        </div>
      </Float>
    </Menu>
  </div>
</template>
